$(document).ready(function(){

// Const helper
const select = (e) => document.querySelector(e);
const selectAll = (e) => document.querySelectorAll(e);


// Add Gsap plugins
function gsapPlugins() {
    gsap.registerPlugin(ScrollTrigger);
}

//function preloader() {
//    $(window).on('load', function() { // makes sure the whole site is loaded 
//       $('#status').fadeOut(); // will first fade out the loading animation 
//       $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website. 
//       $('body').delay(350).css({'overflow':'visible'});
//       setTimeout(function() { $('body').addClass("body-loaded"); }, 1000);
//    }) 
//
//}
//preloader ();


// images loaded
function preloaderIn(){
    $('main').imagesLoaded().always( function( instance ) {
        gsap.to('.nav-holder', {
            autoAlpha:1,
            duration:0.8,
            delay:0.4
        });

    })
}



// Navigation Away - with updated trigger
function initNavigation(){

    /* Hide Header Nav on on scroll down */
    var didScroll = 800;
    var lastScrollTop = 0;
    var delta = 0;
    var navbarHeight = $('.nav-holder').outerHeight();
    $(window).scroll(function(event){
        didScroll = true;
    });
    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
        function hasScrolled() {
        var st = $(this).scrollTop();
        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('.nav-holder').removeClass('nav-scroll-up').addClass('nav-scroll-down');
            $('.nav-holder').removeClass('nav-hide');
            //$('body').removeClass('menu-open');
            //$('body').removeClass('login-open');
            //$('*').removeClass('menu-hovered');
            //$('*').removeClass('login-hovered');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('.nav-holder').removeClass('nav-scroll-down').addClass('nav-scroll-up');
                //$('.nav-holder').removeClass('nav-hide');
            }
        }
        lastScrollTop = st;
    }
  /* END Hide Header Nav on on scroll down */


    gsap.to("body", {
        scrollTrigger: {
            start: "top+=55 top",
            end: 'bottom top-=9999',
            //onEnter: ({direction}) => scrollDirection(direction),
            //onLeaveBack: ({direction}) => scrollDirection(direction),
            //onUpdate: ({direction}) => scrollDirection(direction),
            //markers:true,
            //onUpdate: self => console.log("direction:", self.direction)
        }
    });

    gsap.to("body", {
        scrollTrigger: {
           trigger: "main",
            //start: () => "+=" + document.querySelector(".nav-holder").offsetHeight,
            start: "top+=250 top",
            end: 'bottom top-=99999999',
            //markers:{ endColor: "pink",},
            toggleClass: {
                targets: '.nav-holder',
                className: 'nav-moved',
            },
        }
    });

    gsap.to("body", {
        scrollTrigger: {
           trigger: "main",
            //start: () => "+=" + document.querySelector(".header-home-content").offsetHeight*0.9,
            //start: () => "+=" + document.querySelector(".nav-holder").offsetHeight*4,
            start: "top+=10 top",
            end: 'bottom top-=99999999',
            //markers:{ endColor: "pink",},
            toggleClass: {
                targets: '.nav-holder',
                className: 'nav-moved-background',
            },
        }
    });
}


function menu(){
     $('.menu-opener, .nav-overlay').click(function(){
        $('nav').toggleClass('menu-opened');
        $('body').toggleClass('body-menu-opened');
    });

    $(".nav-primary > li.menu-item-has-children > a").click(function(e) {
        $(this).toggleClass('open');
        $(this).parent().toggleClass("open");
    })

    $(".nav-primary > li.menu-item-has-children > a, .no-link > a").click(function(e) {
        e.preventDefault();
        e.stopPropagation();
    })


    $('.no-touch .nav-primary .menu-item-has-children').mouseover(function() {
        $(this).addClass('menu-hovered');
        $(this).siblings().addClass('pe-none');
        $('body').addClass('menu-open');
        $('body').addClass('nav-invert-hover');
    });
    $('.no-touch .nav-primary .menu-item-has-children').mouseleave(function() {
        $(this).removeClass('menu-hovered');
        $('body').removeClass('menu-open');
        $('body').removeClass('nav-invert-hover');

        setTimeout(() => {
            $(this).siblings().removeClass('pe-none');
        }, 50);
    });


    $('.touch .nav-primary .menu-item-has-children').mouseover(function() {
        $(this).addClass('menu-hovered');
        $('body').addClass('menu-open');
        $('body').addClass('nav-invert-hover');
    });
    $('.touch .nav-primary .menu-item-has-children').mouseleave(function() {
        $(this).removeClass('menu-hovered');
        $('body').removeClass('menu-open');
        $('body').removeClass('nav-invert-hover');
    });


}


function lazyLoad(){
    window.lazySizesConfig.init = true;
    window.lazySizesConfig.loadHidden = false;
}




function scrubParallax() {
     // select all sections .with-parallax
    gsap.utils.toArray('.scrub-parallax').forEach(section => {
        // get the image
        const image = section.querySelector('.scrub-parallax img, .scrub-parallax video');
        // create tween for the image
        gsap.to(image, {
            y: '20%',
            ease: 'none',
            scrollTrigger: {
                id: "parallax-1",
                trigger: section,
                start: 'section bottom',
                scrub: true,
                //markers:true
            }
        });
    });
}  

function scrubZoom() {
     // select all sections .with-parallax
    gsap.utils.toArray('.scrub-zoom').forEach(section => {
        // get the image
        const image = section.querySelector('.scrub-zoom img, .scrub-zoom video');
        // create tween for the image
        gsap.to(image, {
            scale: 1,
            transformOrigin:"50% 50%",
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'section bottom',
                end: 'bottom center',
                scrub: 0.5,
                //markers:true
            }
        });
    });
}   

function scrubY() {
     ScrollTrigger.matchMedia({
        "(min-width:992px)": function() {
            const scrubY = gsap.utils.toArray('.scrub-Y');
            var scrubY1Parent = $(scrubY).parent();
            scrubY.forEach(item => {
                var scrubY1i = $(item)[0];
                var yAttribute = scrubY1i.getAttribute("translatey");
                //console.log(scrubY1Parent);
                gsap.from(item, {
                    scrollTrigger: {
                        trigger: scrubY1Parent,
                        start: 'top bottom',
                        end: 'center 70%',
                        scrub: 0.8,
                        id: "scrubY",
                        //markers:true
                    },
                    y: yAttribute,
                    ease: 'none',
                });
            });
        }
    });
}


function animationReveal(){
    $('main').imagesLoaded().always( function( instance ) {

        let revealContainers = document.querySelectorAll(".reveal-holder");
        revealContainers.forEach(container => {
            let wrapper = container.querySelectorAll(".reveal");
            let image = container.querySelectorAll(".reveal-inner");

            var abc = $(container)[0];
            var topAttribute = abc.getAttribute("start");
            var dataDelay = abc.getAttribute("delay");
            //let topOffset = "50%";

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: topAttribute,
                    toggleActions:"restart none none reverse",
                    //markers:true
                },
            });
            tl.set(wrapper, { autoAlpha: 1});
            tl.from(wrapper, 1, {
                yPercent: 100,
                ease: Power2.out,
                delay:dataDelay
            });
            tl.from(image, 1, {
                yPercent: -100,
                //scale: 1.3,
                delay: -1,
                ease: Power2.out,
            });
        });

    })
}





function animationFade (){
    $('main').imagesLoaded().always( function( instance ) {

        let fadeIn = document.querySelectorAll(".fade-holder");

        fadeIn.forEach(item => {
            let fadeElem = item.querySelectorAll(".fade-in");

            var zzz = $(item)[0];
            var topAttribute = zzz.getAttribute("start");
            var dataDelay = zzz.getAttribute("delay");

            let tlfade = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: topAttribute, 
                    toggleActions:"restart none none reverse",
                    //markers:true  
                },
                onComplete:function(){ 
                  //splitTextTitle.revert() 
                },
            });
            tlfade.to(fadeElem, {autoAlpha: 1,duration:0.8, delay:dataDelay, ease: "power1.inOut",});
        });
     })
}


function animationLine(){

    let tlline = gsap.timeline({
        scrollTrigger: {
            trigger: ".line-holder",
            duration: 2,
            delay:2,
            ease: "power4.inOut", 
            start: "top 80%", 
            toggleActions:"restart none none reverse",
            //markers:true  
        },
        onComplete:function(){ 
          //splitTextTitle.revert() 
        },
    });
    tlline
    .addLabel("start")
    .to('.v-line-top em', {scale: 1,stagger: 0.2})
    .to('.v-line span', {height: 200,stagger: 0.2}, "start");


}

function scrollClick(){
    $('.arrow-down-link').click(function(){
        $('html, body').animate({
          scrollTop: $("#below-fold").offset().top
        }, 800, 'easeInOutCirc');
    });

    $('.button-iso').click(function(){
        $('html, body').animate({
          scrollTop: $("#iso-anchor").offset().top
        }, 800, 'easeInOutCirc');
    });
    

    $('.smooth').bind('click', function(event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
          scrollTop: ($($anchor.attr('href')).offset().top - 101)
        }, 800, 'easeInOutCirc');
        event.preventDefault();
    });


}



function tabs(){
 
         // tabbed content
        // http://www.entheosweb.com/tutorials/css/tabs.asp
        $(".tab_content").hide();
        $(".tab_content:first").show();

      /* if in tab mode */
        $("ul.tabs li").click(function() {
            
          $(".tab_content").hide();
          var activeTab = $(this).attr("rel"); 
          $("#"+activeTab).fadeIn();        
            
          $("ul.tabs li").removeClass("active");
          $(this).addClass("active");

          $(".tab_drawer_heading").removeClass("d_active");
          $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
          
        /*$(".tabs").css("margin-top", function(){ 
           return ($(".tab_container").outerHeight() - $(".tabs").outerHeight() ) / 2;
        });*/
        });
        $(".tab_container").css("min-height", function(){ 
          return $(".tabs").outerHeight() + 50;
        });
        /* if in drawer mode */
        $(".tab_drawer_heading").click(function() {
          
          //$(".tab_content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).slideToggle();
          
          //$(".tab_drawer_heading").removeClass("d_active");
          $(this).toggleClass("d_active");
          
          $("ul.tabs li").removeClass("active");
          $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
        });
        
        
        /* Extra class "tab_last" 
           to add border to bottom side
           of last tab 
        $('ul.tabs li').last().addClass("tab_last");*/
        
    
}

function hoverTabs(){
        if (Modernizr.mq('screen and (min-width: 768px)')) {
            $('.nav-hover li').removeClass('active');
            $('.nav-hover li:first-child').addClass('active');

            $(".nav-hover .nav-title").on("mouseenter focus", function(e) {
                $(this).parent().parent().parent().addClass('active');
                $(this).parent().parent().parent().siblings().removeClass('active');
                event.preventDefault();
            })
            $(".nav-hover .nav-title").on("mouseenter focus", function(e) {
                $(this).parent().parent().addClass('active');
            })
            $(".nav-hover .nav-title").on("mouseleave", function(e) {
                $(this).parent().parent().removeClass('active');
            })
        } else if (Modernizr.mq("screen and (max-width:767px)")) {
            $('.nav-hover .nav-title').click(function(){

                $(this).closest('li').toggleClass('active');
                $(this).closest('li').find('.nav-content').slideToggle();

                setTimeout(() => {
                    ScrollTrigger.refresh()
                }, 20);
            });
        };


}

function accordions(){
    $('.accordion > li:first-child').addClass('active').find('.accordion-item').slideDown();
    $('.accordion li > a').click(function(j) {
        var dropDown = $(this).parent().closest('li').find('.accordion-item');
        // This closes the siblings
        //$(this).closest('.accordion').find('.accordion-item').not(dropDown).slideUp();
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
        } else {
            // This closes the siblings
            //$(this).closest('.accordion').parent().find('a.active').removeClass('active');
            $(this).parent().addClass('active');
        }
        dropDown.stop(false, true).slideToggle();
        event.preventDefault();

         setTimeout(() => {
            ScrollTrigger.refresh()
        }, 400);
    });


    //$('.content-toggle:first').closest('.content-toggle-container').parent().find('.content-opener').addClass('active');
    //$('.content-toggle:first').closest('.content-toggle-container').closest('.inner-x').find('.content-opener-inner').slideDown();
    //$('.content-toggle:first').addClass('open');
    //$('.content-toggle:first').closest('.section-service').addClass('active');



    $('.content-toggle').click(function(){
        $(this).toggleClass('open');
      
        $(this).closest('.content-toggle-container').parent().find('.content-opener').toggleClass('active');
        $(this).closest('.content-toggle-container').closest('.inner-x').find('.content-opener-inner').slideToggle();

        $(this).closest('.section-service').toggleClass('active');
       
       
        setTimeout(() => {
            ScrollTrigger.refresh()
        }, 400);
    });

   /* $('.col-team').click(function(){
        $('html, body').animate({
          scrollTop: $(this).offset().top
        }, 800, 'easeInOutCirc');
        $(this).toggleClass('open');
        $('.overlay-team').toggleClass('open');
        $('body').toggleClass('overflow-hidden');
        $(this).find('.content-opener').slideToggle();
        if($(this).find('.link-icon div').text() == 'Close'){
             $(this).find('.link-icon div').text('Read more');
        } else {
            $(this).find('.link-icon div').text('Close');
        }
    });

    $(".col-team .content-opener-inner").click(function(e) {
        e.stopPropagation();
    });*/



    //$(".accordion-mobile .accordion-mobile-content:first").show();

    $('.accordion-mobile .accordion-mobile-title').click(function(j) {
        var dropDown = $(this).parent().find('.accordion-mobile-content');
        // This closes the siblings
        //$(this).closest('.accordion').find('.accordion-item').not(dropDown).slideUp();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            // This closes the siblings
            //$(this).closest('.accordion').find('a.active').removeClass('active');
            $(this).addClass('active');
        }
        dropDown.stop(false, true).slideToggle();
        event.preventDefault();

         setTimeout(() => {
            ScrollTrigger.refresh()
        }, 400);

    });
}



function forms(){

    $('select.select-control').each(function(){
        var $this = $(this), numberOfOptions = $(this).children('option').length;
      
        $this.addClass('select-hidden'); 
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        var $labelSelect = $this.closest('.float-label').find('label');


        $styledSelect.text($this.children('option').eq(0).text());
      
        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);
      
        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }
      
        var $listItems = $list.children('li');
      
        $styledSelect.click(function(e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function(){
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
            $labelSelect.addClass('active'); 
        });
      
        $listItems.click(function(e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            //console.log($this.val());
        });
      
        $(document).click(function() {
            $styledSelect.removeClass('active');
            //$labelSelect.removeClass('active'); 
            $list.hide();
        });

    });


    $(document).on('focus','form input,form textarea,form select',
        function() {
            $(this).closest('.float-label').find('label').addClass('active'); 
        }
    );
    $(document).on('blur','form input,form textarea,form select',
        function() {
            if($(this).closest('.float-label').find('input').val()=='' || $(this).closest('.float-label').find('textarea').val()=='' || $(this).closest('.float-label').find('select').val()=='' )
            $(this).closest('.float-label').find('label').removeClass('active');  
        } 
    );
    $('form input,form textarea,form select').each(function(){
        if ($(this).val().length > 0) {
            $(this).closest('.float-label').find('label').addClass('active'); 
        }
        else{
        
        }
    });
}




function Cf7Init(){
    var loader = $('.barba-container').find('.ajax-loader');
    //console.log(loader);
    if (!loader.length) {      
        $( 'div.wpcf7 > form' ).each( function() {
            var $form = $( this );
                wpcf7.init($form[0]);
                //if ( wpcf7.cached ) {
                //    wpcf7.refill($form[0]);
                //}
        } );
    } 
}


function Cf7Init2(){
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        if ( '32' == event.detail.contactFormId ) {
            location = '/thank-you/';
        }  else if ( '18882' == event.detail.contactFormId ) {
            $('.download-brochure').css('display', 'flex');
             // Change data-brochure to href and remove data-lity
            document.querySelectorAll('[data-brochure]').forEach(function(element) {
                element.setAttribute('href', element.getAttribute('data-brochure'));
                element.removeAttribute('data-brochure');
                element.removeAttribute('data-lity');
            });
        }
        //else if ( '1070' == event.detail.contactFormId ) { // Sends submissions on form 1070 to the second thank you page
        //    location = 'https://www.example.com/thank-you-2/';
        //} else { // Sends submissions on all unaccounted for forms to the third thank you page
        //    location = 'https://www.example.com/thank-you-3/';
        //}
    }, false );

}

function textimonialsSlider(){
   var $car1 = $('.carousel-testimonials').flickity({
        pageDots: true,
        prevNextButtons: false, 
        fade: true,
        autoPlay: 5000,
        wrapAround: true,
        //adaptiveHeight:true
    });
}


function historySlider(){
   // init Flickity
    var $carouselHistory = $('.history-carousel').flickity({
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      fade: true,
      //autoPlay: 4000,
    });
    // Flickity instance
    var flkty = $carouselHistory.data('flickity');
    // elements
    var $cellButtonGroup = $('.history-pagination');
    var $cellButtons = $cellButtonGroup.find('.history-button');

    // update selected cellButtons
    $carouselHistory.on( 'select.flickity', function() {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
    });

    // select cell on button click
    $cellButtonGroup.on( 'click', '.history-button', function() {
      var index = $(this).index();
      $carouselHistory.flickity( 'select', index );
    });
    // previous
    $('.history-button-previous').on( 'click', function() {
      $carouselHistory.flickity('previous');
    });
    // next
    $('.history-button-next').on( 'click', function() {
      $carouselHistory.flickity('next');
    });
}

function gallerySlider(){
   var $car1 = $('.carousel-gallery').flickity({
        pageDots: true,
        prevNextButtons: false, 
        //fade: true,
        autoPlay: 4000,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        imagesLoaded: true,
        //adaptiveHeight:true
    });
}



function buttons(){
    const mainNavLinks = gsap.utils.toArray('.btn-js');
    mainNavLinks.forEach(link => {
        link.addEventListener('mouseleave', e => {
            // add class
            link.classList.add('btn-js-hover');

        });
        link.ontransitionend = function() {
            //remove class
            link.classList.remove('btn-js-hover');
        }
    });

}




function secondaryNav(){
    /* Pin nav */
    ScrollTrigger.create({
      trigger: ".nav-pin",
      endTrigger: ".triggerNavEnd",
      start: "top 20%", 
      end: "center center", 
      pin: true, 
      pinSpacing: false,
      id: "pin-1",
      //markers:true,
    });

    $("body").scrollspy({
        target: ".scrollspy-nav",
        offset: 300
    })

}






function anchor() {
    if ( window.location.hash ) {
        setTimeout(function() {
            $('html,body').animate({
              scrollTop: $(window.location.hash).offset().top -0 
            }, 1000, 'easeInOutCirc');
        }, 500);
    }
}


function loadMore() {
    /* Load more 1 */
    $("#load-more-1 .load-more-block").slice(0, 9).show({
      start: function () {
        $(this).css({
          display: "block"
        })
      }
    });
    if ($("#load-more-1 .load-more-block").length > 4) {
        $("#load-more-1.load-more-container, #load-more-1 #loadMore").css({
            display: "block"
        })
    }
    $("#load-more-1 #loadMore").on("click", function(e) {
        e.preventDefault();
        event.preventDefault();
        $("#load-more-1 .load-more-block:hidden").slice(0, 6).slideDown ({
            duration: 600,
            ease: "easeInOutCirc", 
            start: function() {
                $(this).css({
                    display: "block"
                });
                ScrollTrigger.refresh()
            }
        });
        if ($("#load-more-1 .load-more-block:hidden").length == 0) {
            $("#load-more-1 #loadMore").slideUp();
        }
    });



    $("#load-more-2 .load-more-block").slice(0, 4).show({
      start: function () {
        $(this).css({
          display: "block"
        })
      }
    });
    if ($("#load-more-2 .load-more-block").length > 4) {
        $("#load-more-2.load-more-container, #load-more-2 #loadMore").css({
            display: "block"
        })
    }
    $("#load-more-2 #loadMore").on("click", function(e) {
        e.preventDefault();
        event.preventDefault();
        $("#load-more-2 .load-more-block:hidden").slice(0, 4).slideDown ({
            duration: 600,
            ease: "easeInOutCirc", 
            start: function() {
                $(this).css({
                    display: "block"
                });
                ScrollTrigger.refresh()
            }
        });
        if ($("#load-more-2 .load-more-block:hidden").length == 0) {
            $("#load-more-2 #loadMore").slideUp();
        }
    });

}


function phoneClick() {
    $( '.clickToShow' ).each( function() {
           var shortNumber3 = $(this).text().substring(0,  $(this).text().length - 8);
        $(this).hide().after('<span class="hide-touch phone-track clickToShowButton">' + shortNumber3 + '<span> Click to show</span></span>');
        $(".clickToShowButton").click(function() {
            $(this).siblings().show();
            $(this).hide();
        });
    });


    document.querySelectorAll(".no-barba a").forEach(item=>item.setAttribute('data-barba-prevent','self')); 
    document.querySelectorAll("a[href='/shop/']").forEach(item=>item.setAttribute('data-barba-prevent','self')); 
    document.querySelectorAll("a[href='/shop/product-category/mechanical-assembly/']").forEach(item=>item.setAttribute('data-barba-prevent','self')); 
    document.querySelectorAll("a[href='/shop/product-category/cooling-tower-fill/fill/']").forEach(item=>item.setAttribute('data-barba-prevent','self')); 
    document.querySelectorAll("a[href='/shop/product-category/drift-eliminators/drift/']").forEach(item=>item.setAttribute('data-barba-prevent','self')); 

}


function googleTracking() {
    $( "#menu-item-1581 a" ).click(function() {
        gtag('event', 'login_click', {
            'event_category': 'Login',
            'event_label': ''
        });
    });
    
    $( "#menu-item-1582 a" ).click(function() {
        gtag('event', 'calculator_click', {
            'event_category': 'Calculator',
            'event_label': ''
        });
    });
}


function popup() {

            /*Scroll Modal + Slide in*/

            // $(window).on("scroll.scrollSlide", function() {   
            //     var scrollHeight = $(".classScroll").attr("scroll-lenth"); 
            //     //var scroll = $(window).scrollTop();

            //     var windowHeight = jQuery(window).height();
            //     var docHeight = jQuery(document).height();
            //     var scrollTop = jQuery(window).scrollTop();
            //     var trackLength = docHeight - windowHeight;
            //     var amountScrolled = scrollTop / trackLength*100 || 0;

            //     // Stop scroll after attribute height is reached
            //     if(amountScrolled >= scrollHeight) $(window).off('scroll.scrollSlide');

            //     //console.log(amountScrolled);

            //     var mytimeout;
            //     if (amountScrolled >= scrollHeight) {
            //         $(".classScroll").addClass("open");
            //         var mytimeout = setTimeout(function() {
            //             $('.slide-in.classScroll').removeClass('open');
            //             $('.slide-in-bar').addClass('open');
            //         }, 5000);
            //     };

            //     $('.slide-in').mouseover(function() {
            //         //console.log('rrr')
            //         clearTimeout(mytimeout);
            //     });

                

            // });


            // Create a ScrollTrigger instance
            // const scrollSlideElement = document.querySelector('.scrollSlide');

            // if (scrollSlideElement) {
            //     // Create a ScrollTrigger instance
            //     ScrollTrigger.create({
            //         start: "1200px top", // Start when the scroll position reaches 1200px
            //         //markers:true,
            //         onEnter: () => scrollSlideElement.classList.remove('open'), // Remove class when scrolling down
            //         onLeaveBack: () => scrollSlideElement.classList.add('open'), // Add class when scrolling up
            //         toggleActions: "play none none reverse" // Ensure the class is toggled correctly
            //     });
            // } else {
            //     console.error('Element with class "scrollSlide" not found.');
            // }
    

            $(".classScroll").addClass("open");
                /*Close modal*/
                $('.itemClose, .modal-inner .btn-mobile').click(function() {
                    $('.modal').removeClass('open');
                    setTimeout(function() {
                        $('.modal').remove();
                    }, 300);


                    /* Set cookie on close */
                    var $getModalParent = $(this).closest( ".modal" );
                    var $ModalParentID = $($getModalParent).attr('id');
                    $.cookie($ModalParentID, 'true', { expires: 7, path: '/' });

                });

            /* Check if cookie exists */
            var $getModalParent2 = $('.modal').attr('id');
            
            function mouseintentLeave(){
                $(function(){
                    var mouseY = 0;
                    var topValue = 0;
                    window.addEventListener("mouseout",function(e){
                        mouseY = e.clientY;
                        if(mouseY<topValue) {
                            $('.exitIntent').addClass('open');
                        }
                    },
                    false);
                });
            }       



            var mytimeoutModal;
            if ($.cookie($getModalParent2)) {
                $('.modal').remove();
                $('.exitIntent').removeClass('open');
                clearTimeout(mytimeoutModal);
            } else {
                var mytimeoutModal = setTimeout(function() {
                    mouseintentLeave();
                }, 100);
            }



            //
               


            //


        /* Slide-in CTA */
          
            $('.slideClose').click(function() {
                $(window).off('scroll'); 
                $('.slide-in').removeClass('open');
                $('.slide-in-bar').removeClass('open');
                setTimeout(function() {
                    $('.slide-in').remove();
                }, 300);
            });

            $('.slide-in-bar').click(function() {
                $('.slide-in').addClass('open');
            });

            $('.slide-in').mouseleave(function() {
                setTimeout(function() {
                    $('.slide-in').removeClass('open');
                    $('.slide-in-bar').addClass('open');
                }, 300);
            });

}


function lityf(){


    $(document).on('lity:ready', function(e, instance) {
        instance.element().find('video').each(function() {
            $(this).trigger('play');
            $(this).animate({volume: 1}, 1000); // fade in over 1 second
        });


    });
    $(document).on('lity:close', function(e, instance) {
        instance.element().find('video').each(function() {
            $(this).animate({volume: 0}, 1000, function() {
                $(this).trigger('pause');
            }); // fade out over 1 second, then pause
        });

    });
}

$(document).ready(function() {
    // Function to open Lity lightbox if hash exists
    function openLityFromHash() {
        var hash = window.location.hash;
        if (hash && $(hash).length) {
            lity(hash);
        }
    }

    // Call the function on page load
    //openLityFromHash();

    // Optional: Call the function when the hash changes (e.g., user navigates back/forward)
    $(window).on('hashchange', function() {
       // openLityFromHash();
    });

});



function search (){
    /* Search */
    var $input = $(".search-input")
    $('.search-opener').click(function() {
        $('body').toggleClass('search-open');
        //setTimeout(function(){
            $input.focus();
        //},600); 
    });
    $('.search-overlay, .siq-autocomplete').click(function() {
        $('body').removeClass('search-open');
    });
    /* END Search */
    
}
    

    


function careersSlider(){
   var $carCareers = $('.carousel-careers').flickity({
        pageDots: true,
        cellAlign: 'center',
        prevNextButtons: false, 
        //fade: true,
        autoPlay: 3000,
        wrapAround: true,
        //adaptiveHeight:true
    });
}

function brochures(){
    document.querySelectorAll('[data-brochure]').forEach(function(element) {
        element.addEventListener('click', function() {
            setTimeout(() => {
                var brochureValue = element.getAttribute('data-brochure');
                document.querySelectorAll('input[name="brochure-1"]').forEach(function(input) {
                    input.value = brochureValue;
                });
            }, 300);
        });
    });
}


function esg (){
    gsap.timeline({
        scrollTrigger:{
          trigger: "body",
          scrub:1,
          start: 'top top',
          end:'+=10000',
        }
    })
    .to('.spinners', {
        rotation:360*2,
        duration:1, 
        ease:'none',
    })
}

function heights() {
    // Function to update max height for elements
    function updateMaxHeight() {
       const updateHeightForClass = (className, cssVariable) => {
           const elements = document.querySelectorAll(`.${className}`);
           let maxHeight = 0;
           elements.forEach(element => {
               const height = element.offsetHeight;
               if (height > maxHeight) {
                   maxHeight = height;
               }
           });
           document.documentElement.style.setProperty(cssVariable, `${maxHeight}px`);
       };

       updateHeightForClass('box-height', '--box-height');
       updateHeightForClass('box-height-2', '--box-height-2');
   }

   updateMaxHeight();

   $(window).on('resize', () => {
       updateMaxHeight();
   });
}

/* BARBA.JS */


barba.hooks.beforeOnce(() => {
    
});


barba.hooks.once((data) => {

});

barba.hooks.beforeEnter((data) => {
    window.scrollTo(0, 0);

    preloaderIn();
    esg();
   
    
    brochures();
    //carousels();
    gsapPlugins ();
    initNavigation ();
    menu();

    animationReveal();

    animationFade();

    scrollClick();
    search ();
    
   
    forms();

    loadMore();
    anchor();
    gallerySlider();
    googleTracking();
    // WebFont.load({
    //     custom: {
    //         families: ['OgilvySerif', 'OgilvySans'],
    //         urls: ['../css/bootstrap.css']
    //     },
    //     fontactive: function(fontFamily, fontDescription) {
    //         //console.log( 'google font active', fontFamily, fontDescription );
    //     }
    // });
            //splitText();
    //hoverTabs();
    /* Add above when ready - Issue with browsersync */
    


    setTimeout(() => { 
        heights();
        
        Cf7Init2();

        lityf();
        tabs();
        
        accordions();
        phoneClick();
        scrubY();
        scrubParallax();
        scrubZoom();
        secondaryNav();
        lazyLoad();
        setTimeout(() => {
            popup();
        }, 100);
        window.ga('send', 'pageview', window.location.pathname || url);
        ScrollTrigger.refresh()
    }, 200);



    $('.autoplay').trigger('play');


    
});


barba.hooks.afterLeave((data) => {
    $('body').removeClass('body-menu-opened');
    $('body').removeClass('menu-open');
    $('body').removeClass('nav-invert-hover');
    $('body').removeClass('overflow-hidden');
    $('body').removeClass('search-open');


    ScrollTrigger.getById("scrubY").kill();
    //ScrollTrigger.getById("pin-2").kill();

});





barba.hooks.enter ((data) => {

        
    setTimeout(() => { 
        Cf7Init();
     }, 300);

    window.scrollTo(0, 0);
})


/* Page animations */
const animationEnter = (container) => {
    return gsap.from(container, {autoAlpha:0, duration:0.3, ease:'none'})
}

const animationLeave = (container) => {
    return gsap.to(container, {autoAlpha:0, duration:0.3, ease:'none' })
}

barba.init ({
    debug: true,
    timeout: 8000,
    views: [
     {
            namespace: 'home',
            beforeEnter (data){
                setTimeout(() => { 
                    textimonialsSlider();
                }, 500);
                animationLine();
            }
        },
        
        {
            namespace: 'cooling-towers',
            beforeEnter (data){
                setTimeout(() => { 
                   
                }, 300);
               
            }
        },
        {
            namespace: 'about',
            beforeEnter (data){
                setTimeout(() => { 
                   //historySlider();
                }, 300);
               
            }
        },
        {
            namespace: 'careers',
            beforeEnter (data){
                setTimeout(() => { 
                   careersSlider();
                }, 500);
               
            }
        }
       
    ],
    transitions: [
        {
            once({next}){
                //animationEnter(next.container);
                
                
            },
             beforeEnter: function({ next }) {
            },
            
            leave:({current}) => animationLeave(current.container),
            enter({next}){
                animationEnter(next.container);
            },
        }
    ]
})

});